// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BWjy","rightAdornment":"Header_rightAdornment__3mmSO"};